import { render, staticRenderFns } from "./TermosUso.vue?vue&type=template&id=a94fa93a&"
import script from "./TermosUso.vue?vue&type=script&lang=js&"
export * from "./TermosUso.vue?vue&type=script&lang=js&"
import style0 from "./TermosUso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports